
import { Component, Prop, Vue } from "vue-property-decorator";
import t from "@common/src/i18n/t";
@Component({})
export default class DataEmptyGuide extends Vue {
  @Prop({ default: () => t("base.no-data") })
  emptyText: string;
  @Prop({ default: "" })
  guideText: string;
  @Prop({ default: "" })
  guideUrl: string;
}
